<template>
  <div class="container-xxl founders-page py-5">
    <div class="container">
      <div class="founders-hero">
        <div>
          <h6 class="section-title text-start text-primary text-uppercase">Kurucular</h6>
          <h1>Derneğin kuruluşunda emeği geçen hemşehrilerimiz</h1>
          <p>
            Başkent Ağrılılar Derneği, Ankara'da yaşayan Ağrılıların dayanışmasını
            büyütmek için farklı mesleklerden hemşehrilerimizin ortak emeğiyle kuruldu.
          </p>
        </div>
        <div class="founders-summary">
          <span>{{ KURUCULAR.length }}</span>
          <strong>Kurucu üye</strong>
          <small>Dayanışma, emek ve gönüllülük</small>
        </div>
      </div>

      <div class="founders-layout">
        <aside class="founders-note">
          <i class="fas fa-hands-helping"></i>
          <h2>Ortak emek</h2>
          <p>
            Kurucu listemiz, derneğin bugünlere gelmesinde sorumluluk alan
            hemşehrilerimize saygı ve teşekkür amacıyla yayınlanmaktadır.
          </p>
          <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary">
            <i class="fab fa-whatsapp me-2"></i>Aramıza Katıl
          </a>
        </aside>

        <div class="founders-list" aria-label="Kurucu üyeler listesi">
          <article
            v-for="(kurucu, index) in KURUCULAR"
            :key="index"
            class="founder-row"
          >
            <div class="founder-index">{{ String(index + 1).padStart(2, '0') }}</div>
            <div class="founder-main">
              <h2>{{ kurucu.name }}</h2>
              <p>{{ kurucu.title }}</p>
            </div>
            <div class="founder-badge">
              <i class="fas fa-check"></i>
              <span>Kurucu</span>
            </div>
          </article>
        </div>
      </div>

      <div class="founders-cta">
        <div>
          <h2>Ankara'daki Ağrılılar için güçlü bir dayanışma ağı</h2>
          <p>Dernek faaliyetlerine katılmak, destek vermek veya bilgi almak için bizimle iletişime geçebilirsiniz.</p>
        </div>
        <div class="founders-cta-actions">
          <a href="tel:+905079217404" class="btn btn-dark">
            <i class="fa fa-phone-alt me-2"></i>Derneği Ara
          </a>
          <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary">
            <i class="fab fa-whatsapp me-2"></i>WhatsApp
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import KURUCULAR from '@/data/kurucular';

const whatsappJoinUrl = `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, herkese merhabalar.')}`;
</script>

<style scoped>
.founders-page {
  background:
    linear-gradient(180deg, #FFFFFF 0%, #F7FAFC 42%, #FFFFFF 100%);
}

.founders-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  gap: 32px;
  align-items: end;
  margin-bottom: 34px;
}

.founders-hero h1 {
  color: var(--dark);
  font-size: clamp(32px, 4vw, 52px);
  line-height: 1.08;
  max-width: 820px;
  margin: 0 0 18px;
}

.founders-hero p {
  color: #5B6475;
  font-size: 18px;
  line-height: 1.7;
  max-width: 780px;
  margin: 0;
}

.founders-summary {
  background: var(--dark);
  color: #FFFFFF;
  padding: 26px;
  min-height: 190px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(15, 23, 43, .14);
}

.founders-summary span {
  color: var(--primary);
  font-size: 58px;
  font-weight: 800;
  line-height: 1;
}

.founders-summary strong {
  font-size: 20px;
  margin-top: 10px;
}

.founders-summary small {
  color: rgba(255, 255, 255, .76);
  margin-top: 8px;
}

.founders-layout {
  display: grid;
  grid-template-columns: 310px minmax(0, 1fr);
  gap: 28px;
  align-items: start;
}

.founders-note {
  position: sticky;
  top: 118px;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 14px 35px rgba(15, 23, 43, .08);
}

.founders-note i {
  color: var(--primary);
  font-size: 34px;
  margin-bottom: 18px;
}

.founders-note h2,
.founders-cta h2 {
  color: var(--dark);
  font-size: 24px;
  margin-bottom: 12px;
}

.founders-note p,
.founders-cta p {
  color: #606A7A;
  line-height: 1.7;
}

.founders-note .btn {
  width: 100%;
  margin-top: 10px;
}

.founders-list {
  display: grid;
  gap: 12px;
}

.founder-row {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr) auto;
  gap: 18px;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 4px solid var(--primary);
  border-radius: 8px;
  padding: 18px 20px;
  box-shadow: 0 10px 28px rgba(15, 23, 43, .06);
}

.founder-index {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #FFF4DF;
  color: var(--primary);
  font-weight: 800;
  border-radius: 50%;
}

.founder-main h2 {
  color: var(--dark);
  font-size: 20px;
  margin: 0 0 5px;
}

.founder-main p {
  color: #646D7D;
  margin: 0;
}

.founder-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #1F7A4D;
  background: #EAF7EF;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 11px;
  border-radius: 999px;
}

.founder-badge i {
  font-size: 11px;
}

.founders-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 34px;
  background: #F8FAFC;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  padding: 28px;
}

.founders-cta p {
  margin: 0;
}

.founders-cta-actions {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

@media (max-width: 991.98px) {
  .founders-hero,
  .founders-layout {
    grid-template-columns: 1fr;
  }

  .founders-summary {
    min-height: auto;
  }

  .founders-note {
    position: static;
  }

  .founders-cta {
    align-items: stretch;
    flex-direction: column;
  }

  .founders-cta-actions {
    flex-wrap: wrap;
  }
}

@media (max-width: 575.98px) {
  .founders-page {
    padding-bottom: 86px !important;
  }

  .founders-hero h1 {
    font-size: 32px;
  }

  .founders-hero p {
    font-size: 16px;
  }

  .founder-row {
    grid-template-columns: 44px minmax(0, 1fr);
    padding: 16px;
  }

  .founder-index {
    width: 38px;
    height: 38px;
    font-size: 13px;
  }

  .founder-main h2 {
    font-size: 18px;
  }

  .founder-badge {
    grid-column: 2;
    justify-self: start;
  }

  .founders-cta-actions .btn {
    width: 100%;
  }
}
</style>
